<template>
    <div v-if="!isLoading && chartData.length > 0" class="EntityDetailsChart">
        <ChartV2
            type="bar"
            halfHeight
            color="green"
            :title="`Umsatz ${currentMonthDisplay}`"
            :values="chartData"
            :isLoading="isLoading"
        />
    </div>
</template>

<script>
import { startOfMonth, endOfMonth, format } from 'date-fns';
import { de } from 'date-fns/locale';
import { fillAllDaysInDateRange } from '@/lib/helper';
import ChartV2 from '@/components/widgets/ChartV2.vue';

export default {
    name: 'EntityDetailsChart',
    components: {
        ChartV2,
    },
    props: {
        shifts: {
            type: Array,
            default: () => [],
        },
        currentMonth: {
            type: Date,
            required: true,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        chartData() {
            const startOfSelectedMonth = startOfMonth(this.currentMonth);
            const endOfSelectedMonth = endOfMonth(this.currentMonth);

            if (!this.shifts?.length) {
                return fillAllDaysInDateRange(startOfSelectedMonth, endOfSelectedMonth, [], false);
            }

            const dailyRevenue = {};

            this.shifts.forEach((shift) => {
                if (!shift?.startAt) return;

                const date = new Date(shift.startAt);
                const dateKey = format(date, 'yyyy-MM-dd');
                const revenue = shift.finalTotalAmount || 0;

                if (!dailyRevenue[dateKey]) {
                    dailyRevenue[dateKey] = {
                        date: dateKey,
                        revenue: 0,
                    };
                }

                dailyRevenue[dateKey].revenue += revenue;
            });

            const dailyIncome = Object.values(dailyRevenue).map((data) => ({
                date: data.date,
                income: data.revenue,
            }));

            return fillAllDaysInDateRange(
                startOfSelectedMonth,
                endOfSelectedMonth,
                dailyIncome,
                false,
            );
        },
        currentMonthDisplay() {
            return format(this.currentMonth, 'MMMM yyyy', { locale: de });
        },
    },
};
</script>

<style lang="scss" scoped>
.EntityDetailsChart {
    margin-bottom: 24px;
}
</style>
